export const concatenateBlobs = async (blobs: Blob[], type: string = "audio/wav"): Promise<Blob> => {
    const promiseBuffers: Array<Promise<ArrayBuffer>> = [];

    blobs.forEach((blob) => {
        promiseBuffers.push(readFileAsync(blob));
    });

    return await Promise.all(promiseBuffers)
        .then(async (buffers) => {
            const blob = concatenateBuffers(buffers, type);
            return await Promise.resolve(blob);
        })
        .catch(async (error) => {
            return await Promise.reject(error);
        });
};

export const readFileAsync = async (blob: Blob): Promise<ArrayBuffer> => {
    return await new Promise((resolve, reject) => {
        const reader = new FileReader();

        reader.addEventListener("loadend", function () {
            resolve(reader.result as ArrayBuffer);
        });

        reader.onerror = reject;

        reader.readAsArrayBuffer(blob);
    });
};

const audioLengthTo32Bit = (num: number): number[] => {
    num = Math.floor(num);
    const b1 = num & 255;
    const b2 = (num >> 8) & 255;
    const b3 = (num >> 16) & 255;
    const b4 = (num >> 24) & 255;

    return [b1, b2, b3, b4];
};

const concatenateBuffers = (buffers: ArrayBuffer[], type: string): Blob => {
    let byteLength = 0;

    buffers.forEach((buffer) => {
        if (buffer.byteLength) {
            byteLength += buffer.byteLength;
        }
    });

    const tmp = new Uint8Array(byteLength);
    let lastOffset = 0;
    let newData;

    buffers.forEach((buffer) => {
        if (type === "audio/wav" && lastOffset > 0) newData = new Uint8Array(buffer, 44);
        else newData = new Uint8Array(buffer);
        tmp.set(newData, lastOffset);
        lastOffset += newData.length;
    });

    if (type === "audio/wav") {
        try {
            tmp.set(audioLengthTo32Bit(lastOffset - 8), 4);
            tmp.set(audioLengthTo32Bit(lastOffset - 44), 40); // update audio length in the header
        } catch {}
    }

    const blob = new Blob([tmp.buffer], {
        type
    });

    return blob;
};
